module.exports = __webpack_public_path__ + "img/zhinengzhizao_ximenzi_suoluetu.fdc70dd1.png";